import { render, staticRenderFns } from "./ruleEditModel.vue?vue&type=template&id=3211133a"
import script from "./ruleEditModel.vue?vue&type=script&lang=js"
export * from "./ruleEditModel.vue?vue&type=script&lang=js"
import style0 from "./ruleEditModel.vue?vue&type=style&index=0&id=3211133a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports